import { render } from "./ExtensionPromo.vue?vue&type=template&id=7b34e9d2&scoped=true"
import script from "./ExtensionPromo.vue?vue&type=script&lang=js"
export * from "./ExtensionPromo.vue?vue&type=script&lang=js"

import "./ExtensionPromo.vue?vue&type=style&index=0&id=7b34e9d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b34e9d2"]])

export default __exports__